import "./index.scss";

export const CartCardDescription = ({ cardTypes, name, cardUrl }) => {
  return (
    <div className={"description"}>
      <a className={"card-name"} href={cardUrl}>
        {name}
      </a>
      {cardTypes.map((c) => (
        <span className={"card-type"} key={c.content}>
          {c.content}
        </span>
      ))}
    </div>
  );
};
